var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m387.302 125.987c3.001-6.026 4.698-12.81 4.698-19.987 0-24.813-20.187-45-45-45s-45 20.187-45 45c0 7.177 1.697 13.961 4.698 19.987-71.564 18.032-124.698 82.93-124.698 160.013 0 90.981 74.019 165 165 165s165-74.019 165-165c0-77.083-53.134-141.981-124.698-160.013zm-55.302-19.987c0-8.271 6.729-15 15-15s15 6.729 15 15-6.729 15-15 15-15-6.729-15-15zm30 314.162v-14.162c0-8.284-6.716-15-15-15s-15 6.716-15 15v14.162c-62.479-6.939-112.223-56.683-119.162-119.162h14.162c8.284 0 15-6.716 15-15s-6.716-15-15-15h-14.162c6.939-62.479 56.683-112.223 119.162-119.162v14.162c0 8.284 6.716 15 15 15s15-6.716 15-15v-14.162c62.479 6.939 112.223 56.684 119.162 119.162h-14.162c-8.284 0-15 6.716-15 15s6.716 15 15 15h14.162c-6.939 62.479-56.683 112.223-119.162 119.162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137 121h-32c-8.284 0-15 6.716-15 15s6.716 15 15 15h32c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137 211h-62c-8.284 0-15 6.716-15 15s6.716 15 15 15h62c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137 301h-92c-8.284 0-15 6.716-15 15s6.716 15 15 15h92c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137 391h-122c-8.284 0-15 6.716-15 15s6.716 15 15 15h122c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407 271h-45v-45c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.2328fff4.svg";
export { ForwardRef as ReactComponent };